import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import ObserveSize from '../../ObserveSize';
export var HOCObserveSize = function HOCObserveSize(WrappedComponent) {
  return /*#__PURE__*/function (_Component) {
    function HOCObserveSize() {
      var _this;
      _classCallCheck(this, HOCObserveSize);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, HOCObserveSize, [].concat(args));
      _defineProperty(_this, "state", {
        renderWidth: 0
      });
      return _this;
    }
    _inherits(HOCObserveSize, _Component);
    return _createClass(HOCObserveSize, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        return __jsx(ObserveSize, {
          observerFn: function observerFn(contentRect) {
            return _this2.setState({
              renderWidth: contentRect.width
            });
          },
          "data-id": "utils_HOCObserveSize_ObserveSize"
        }, __jsx(WrappedComponent, _extends({}, this.props, {
          renderWidth: this.state.renderWidth,
          "data-id": "utils_HOCObserveSize_WrappedComponent"
        })));
      }
    }]);
  }(Component);
};